<template>
    <div>
      <select v-model="selectedSport">
        <option v-for="sport in sports" :key="sport" :value="sport">{{ sport }}</option>
      </select>
      <select v-model="selectedType">
        <option v-for="typez in types" :key="typez" :value="typez">{{ typez }}</option>
      </select>
    </div>
  </template>
  
  <script>
  import { ref } from 'vue';
  import { useStore } from 'vuex';
  
  export default {
    setup() {
      const store = useStore();
      const sports = ref([]);
      const types = ref([]);
      const selectedSport = ref('');
      const selectedType = ref('');
  
      const fetchSportsAndTypes = async () => {
        const data = await store.dispatch('user/fetchSportsAndTypes');
        sports.value = data.sports;
        types.value = data.types;
      };
      
      fetchSportsAndTypes();
  
      return { sports, types, selectedSport, selectedType };
    }
  }
  </script>
  